module.exports = __webpack_public_path__ + "img/laptop_mac.80327360.svg";